import React from 'react';

function AudioIcon(props: React.ComponentProps<'svg'>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 22"
            fill="currentColor"
            {...props}>
            <path d="M1 16.304a1 1 0 0 1-1-1V5.768a1 1 0 0 1 1-1 1 1 0 0 1 1 1v9.536a1 1 0 0 1-1 1Z" />
            <path d="M5.667 21.071a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1 1 1 0 0 1 1 1v19.071a1 1 0 0 1-1 1Z" />
            <path d="M10.334 16.304a1 1 0 0 1-1-1V5.768a1 1 0 0 1 1-1 1 1 0 0 1 1 1v9.536a1 1 0 0 1-1 1Z" />
            <path d="M15 13.92a1 1 0 0 1-1-1V8.152a1 1 0 0 1 1-1 1 1 0 0 1 1 1v4.768a1 1 0 0 1-1 1Z" />
        </svg>
    );
}

export default AudioIcon;